(function (document, window) {


  document.addEventListener('click', (event) => {
  // Get the clicked element
  const clickedElement = event.target;

  // Log details about the clicked element
  console.log('Element clicked:', clickedElement);
  console.log('Tag name:', clickedElement.tagName);
  console.log('Classes:', clickedElement.className);
  console.log('ID:', clickedElement.id);

  // Additional info: X and Y coordinates of the click
  console.log('Click position:', {
    x: event.clientX,
    y: event.clientY,
  });
});

  
  const SELECTORS = {
    searchBox: '.snize-custom-widget-opener',
    searchButton: '.content_right_icons-search',
    cartButton: '.header__cart_button',
    cartDrawer: '.header__cart__drawer',
    cartCloseButton: '.cart__drawer_close',
  };

  // Utility function to check mobile devices
  function isMobileOrTablet() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipod|android.*mobile|windows.*phone|blackberry|mobile|tablet/.test(userAgent);
  }

  // Initialize cart drawer for mobile devices
  function initMobileCartDrawer() {
    const cartButton = document.querySelector(SELECTORS.cartButton);
    const cartDrawer = document.querySelector(SELECTORS.cartDrawer);
    const cartCloseButton = document.querySelector(SELECTORS.cartCloseButton);

    if (cartButton && cartDrawer && cartCloseButton) {
      cartButton.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.add('open');
      });

      cartCloseButton.addEventListener('click', (e) => {
        e.preventDefault();
        cartDrawer.classList.remove('open');
      });
    }
  }

  // Initialize search button functionality
  function initSearchButton() {
   
    const searchButton = document.querySelector(SELECTORS.searchButton);
    
    const findingSnizeElement = setInterval(() =>{
      const snizeSearchButton = document.querySelector(SELECTORS.searchBox);

      if(snizeSearchButton){

          searchButton.addEventListener('click', function(e) {
              e.preventDefault(); // Prevent default button behavior
            
              // Scroll to the element
              snizeSearchButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
            
              // Add a small delay before triggering the click
              setTimeout(() => {
                snizeSearchButton.click();
              }, 300); // Adjust delay if necessary
            });
        
        
        clearInterval(findingSnizeElement);
      }
      
    }, 500);
        
 
  }

  // Main execution
  function main() {
    if (isMobileOrTablet()) {
      initMobileCartDrawer();
    }
    initSearchButton();
  }

  main();
})(document, window);


// class MobleMenuDrawer extends HTMLElement {
//   constructor() {
//     super();
//     this.open_button = document.querySelector('.header_menu_mobile_button');
//     this.close_button = document.querySelector('.mobile-menu-drawer__close_button');
//     this.dropdowns = this.querySelectorAll('.dropdown');
//     this.sub_dropdowns = this.querySelectorAll('.has-dropdown');
//     this.drawer = this.querySelector('.mobile-menu-drawer');

//    const menuToggle = document.querySelector('.header_menu_mobile_button');
//    const drawerMenu = document.querySelector('.drawer-menu');
//    const overlay = document.querySelector('.overlay');
//    const hasSubmenuItems = document.querySelectorAll('.has-submenu > a');
//    const backButtons = document.querySelectorAll('.submenu .back');

//     this.open_button.addEventListener('click', this.onMenuOpen.bind(this));
//     this.close_button.addEventListener('click', this.onMenuClose.bind(this));

//     this.sub_dropdowns.forEach((el) => {
//       if (el.querySelector('a span')) {
//         el.querySelector('a span').addEventListener('click', function (e) {
//           e.preventDefault();
//           if (el.classList.contains('subdown___dropdown--open')) {
//             let sub_menu = el.querySelector('ul.level--sublink--sublin-menu');
//             let parentElment = el.parentElement;
//             let old_height = parentElment.getAttribute('previus-height');
//             let parrentElementHeight = parseInt(old_height);
//             parentElment.style.height = `${parrentElementHeight}px`;
//             sub_menu.style.height = 0;
//             el.classList.remove('subdown___dropdown--open');
//           } else {
//             el.classList.add('subdown___dropdown--open');
//             let sub_menu = el.querySelector('ul.level--sublink--sublin-menu');
//             let parentElment = el.parentElement;
//             parentElment.setAttribute('previus-height', parentElment.clientHeight);
//             let parrentElementHeight = parentElment.clientHeight + sub_menu.scrollHeight;
//             parentElment.style.height = `${parrentElementHeight}px`;
//             const height = sub_menu.scrollHeight + 'px';
//             sub_menu.style.height = height;
//           }
//         });
//       }
//       // el.querySelector('a .more--icon').addEventListener('click', function (e) {
//       //   e.preventDefault();
//       //   el.classList.add('has-dropdown--open');
//       // });
//     });

//     this.dropdowns.forEach((el) => {
//       el.querySelector('a').addEventListener('click', function (e) {
//         e.preventDefault();
//         if (el.classList.contains('dropdown--open')) {
//           let sub_menu = el.querySelector('ul.level--sublink-menu');
//           sub_menu.style.height = 0;
//           el.classList.remove('dropdown--open');
//         } else {
//           el.classList.add('dropdown--open');
//           let sub_menu = el.querySelector('ul.level--sublink-menu');
//           // console.log(sub_menu);
//           const height = sub_menu.scrollHeight + 'px';
//           sub_menu.style.height = height;
//         }
//       });
//     });
//   }

//   onMenuOpen() {
//     document.body.classList.add('drawer--menu--open');
//     this.drawer.classList.add('open');
//   }

//   onMenuClose() {
//     document.body.classList.remove('drawer--menu--open');
//     this.drawer.classList.remove('open');
//   }
// }

// customElements.define('mobile-drawer-menu', MobleMenuDrawer);


 document.addEventListener('DOMContentLoaded', () => {
            const menuToggle = document.querySelector('.header_menu_mobile_button');
            const drawerMenu = document.querySelector('.mobile-menu-drawer');
            const overlay = document.querySelector('.overlay');
            const hasSubmenuItems = document.querySelectorAll('.has-submenu > a');
            const backButtons = document.querySelectorAll('.submenu .back');

            menuToggle.addEventListener('click', () => {
                drawerMenu.classList.toggle('open');
                overlay.classList.toggle('open');
                menuToggle.classList.toggle('open');
              console.log(drawerMenu, 'drawerMenu');
            });

            hasSubmenuItems.forEach(item => {
              item.addEventListener('click', (e) => {
                  e.preventDefault();
          
                  const link = item;
          
                  // Check if the href is a specific URL or "#" and if the click is inside the arrow
                  if (link.href !== "#" && e.target.closest('.arrow')) {
                      const submenu = item.nextElementSibling;
                      console.log(submenu, e.target.closest('.arrow'));
                      submenu.classList.add('open');
                  } else if (link.href === "#") {
                      // If the href is "#" open the submenu regardless of the click position
                      const submenu = item.nextElementSibling;
                      console.log(submenu, e.target.closest('.arrow'));
                      submenu.classList.add('open');
                  } else {
                      // If neither condition matches, you can do something else or not open the submenu
                      window.location.href = link.href;
                  }
              });
          });

            backButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const currentSubmenu = button.closest('.submenu');
                    currentSubmenu.classList.remove('open');
                });
            });

            // Close drawer menu when clicking outside or on the overlay
            document.addEventListener('click', (e) => {
                if (!drawerMenu.contains(e.target) && !menuToggle.contains(e.target) || overlay.contains(e.target)) {
                    drawerMenu.classList.remove('open');
                    overlay.classList.remove('open');
                    menuToggle.classList.remove('open');
                    // Close all open submenus
                    document.querySelectorAll('.submenu.open').forEach(submenu => {
                        submenu.classList.remove('open');
                    });
                }
            });
});
